import { createApiSlice } from "@common";
import { CRUD_PREFERRED_LANGUAGE } from "@routes";

const apiConfig = [
  {
    name: "addPreferredLanguage",
    method: "post",
    url: CRUD_PREFERRED_LANGUAGE,
    stateKey: "message",
  },
  {
    name: "getPreferredLanguage",
    method: "get",
    url: CRUD_PREFERRED_LANGUAGE,
    stateKey: "data",
  },
  {
    name: "updatePreferredLanguage",
    method: "put",
    url: CRUD_PREFERRED_LANGUAGE,
    stateKey: "message",
  },
  {
    name: "deletePreferredLanguage",
    method: "delete",
    url: CRUD_PREFERRED_LANGUAGE,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice("preferredLanguage", apiConfig, customReducers);
const preferredLanguageSlice = slice;

export default preferredLanguageSlice.reducer;

export const {
  addPreferredLanguage,
  getPreferredLanguage,
  updatePreferredLanguage,
  deletePreferredLanguage,
} = thunks;

export const { rowSelect } = actions;
